import { LegislationEmployeeCostSectionDTO } from "../../models/legislation-employee-cost-section/legislation-employee-cost-section-dto";
import { BaseApiService } from "../base";
import { LegislationEmployeeCostSectionSTO } from "../../models/legislation-employee-cost-section/legislation-employee-cost-section-sto";
import { EmployeeCostSectionTypeRef } from "../../models/employee-cost-section-type/employee-cost-section-type-ref";
import { LegislationEmployeeCostSectionRef } from "../../models/legislation-employee-cost-section/legislation-employee-cost-section-ref";

export class LegislationEmployeeCostSectionApiService extends BaseApiService<
  LegislationEmployeeCostSectionDTO,
  LegislationEmployeeCostSectionSTO
> {
  constructor() {
    super({
      servicePath: "/LegislationEmployeeCostSection",
      loadItemsPath: "/GetLegislationEmployeeCostSection",
      saveItemsPath: "/SaveLegislationEmployeeCostSection",
    });
  }
}
